import { AxiosResponse } from 'axios'
import { api } from 'API'
import { IPracticeRotation } from 'interfaces/plan'

// The shared `api` axios instance auto-stamps `?orgId=` from the active team;
// the server validates membership and derives the org scope from it. No orgId
// is ever sent in the body/query by these calls.

export interface CreatePracticeRotationBody {
  practicePeriodId: number
  name: string
  rotateEveryMinutes: number
  laneIds: number[]
  note?: string
  position?: number
}

/** Create a rotation grouping ≥2 standalone lanes in a period. Returns the created rotation. */
export async function createPracticeRotation(
  body: CreatePracticeRotationBody
): Promise<IPracticeRotation> {
  const response: AxiosResponse = await api.post('/practice-rotations', body)
  return response.data
}

/** Update rotation metadata (name / rotate-every / note). Membership is unchanged here. */
export async function updatePracticeRotation(
  id: number,
  body: { name?: string; rotateEveryMinutes?: number; note?: string }
): Promise<void> {
  await api.patch(`/practice-rotations/${id}`, body)
}

/** Replace the full lane membership of a rotation (≥2 lanes, same period). */
export async function updatePracticeRotationLanes(id: number, laneIds: number[]): Promise<void> {
  await api.put(`/practice-rotations/${id}/lanes`, { laneIds })
}

/** Dissolve a rotation — member lanes revert to standalone; lanes are kept. */
export async function deletePracticeRotation(id: number): Promise<void> {
  await api.delete(`/practice-rotations/${id}`)
}
